import { render } from "./header-search.vue?vue&type=template&id=10a59a48"
import script from "./header-search.vue?vue&type=script&lang=js"
export * from "./header-search.vue?vue&type=script&lang=js"

import "./header-search.vue?vue&type=style&index=0&id=10a59a48&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__